import { render, staticRenderFns } from "./PurchaseDirectSell.vue?vue&type=template&id=0def76fc"
import script from "./PurchaseDirectSell.vue?vue&type=script&lang=js"
export * from "./PurchaseDirectSell.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDirectSell.vue?vue&type=style&index=0&id=0def76fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports